// "ja•••@example.com": the sent screen names the address the visitor typed
// without spelling it out (design/spec/auth/auth.html `maskEmail`). Anything
// without a user part reads as "your email".
export function maskEmail(email) {
  const value = String(email || "")
  const at = value.indexOf("@")
  if (at < 1) return "your email"

  const user = value.slice(0, at)
  const domain = value.slice(at + 1)
  const shown = user.length <= 2 ? `${user[0]}•` : `${user.slice(0, 2)}${"•".repeat(Math.max(2, user.length - 2))}`
  return `${shown}@${domain}`
}
